export default __webpack_public_path__ + "static/media/omsk.3705b31a.pdf";